<template>
  <div class="register">
    <!-- 头部 -->
    <Header></Header>
    <!-- 主体 -->
    <div class="container">
      <div class="w">
        <div class="register">
          <h1 v-if="f==false" class="title">用户注册</h1>
          <h1 v-else class="title">绑定手机号码</h1>
          <!-- 注册框 -->
          <label for="u">
            <div class="uname">
              <span>
                <img src="../assets/icons/uname.png" />
                <div>
                  <input
                    type="text"
                    placeholder="请输入您的手机号码"
                    @input="calibration()"
                    id="u"
                    v-model="registerInfo.mobile"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  />
                </div>
              </span>
            </div>
          </label>
          <label for="p">
            <div class="password">
              <span>
                <img src="../assets/icons/pwd.png" />
                <div>
                  <input type="password" placeholder="请输入密码" id="p" v-model="registerInfo.password" />
                </div>
              </span>
            </div>
          </label>
          <label for="phone">
            <div class="phoneCode">
              <span>
                <img src="../assets/icons/code.png" />
                <div>
                  <input
                    type="text"
                    placeholder="请输入验证码"
                    id="c"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    maxlength="4"
                    v-model="registerInfo.code"
                  />
                </div>
                <!-- 获取验证码 -->
                <button class="getCode">获取验证码</button>
              </span>
            </div>
          </label>
          <label for="u">
            <div class="jname">
              <span>
                <img src="../assets/icons/uname.png" />
                <div>
                  <input
                    type="text"
                    placeholder="请输入您的用户名称(简称)"
                    id="ju"
                    v-model="registerInfo.jname"
                  />
                </div>
              </span>
            </div>
          </label>
          <div class="option clearfix">
            <div class="left">
              <div class="gx">
                <label>
                  <input type="checkbox" class="check" v-model="checkVal" />我已阅读并接受
                </label> &nbsp;&nbsp;&nbsp;
              </div>
              <a href="javascript:;">《云印服务协议》</a>
            </div>
          </div>
          <!-- 注册按钮 -->
          <button v-if="f==false" class="register-btn" @click="register()">注册</button>
          <button v-else class="register-btn" @click="register()">与微信绑定</button>
          <div v-if="f==false" class="register-methods clearfix">
            <a href="javascript:;" @click="goLogin()">已有账号?立即登陆</a>
          </div>
          <div v-else class="register-methods clearfix">
            <a href="javascript:;" @click="dialogVisible=true">已有账号?立即绑定</a>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" width="30%" title="微信绑定">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="账号" prop="account">
            <el-input v-model="ruleForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="bangding('ruleForm')">绑 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 尾部 -->
    <Fotter></Fotter>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '../components/common/Header'
import Fotter from '../components/common/Fotter'

export default {
  name: 'register',
  data() {
    return {
      ruleForm: {
        account: '',
        password: ''
      },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      dialogVisible: false,
      f: false,
      checkVal: false,
      reg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      registerInfo: {
        mobile: '',
        jname: '',
        password: '',
        code: ''
      },
      url: '/api/user/register',
      dt: [{ name: '123' }, { name: '456' }]
    }
  },
  components: {
    Header,
    Fotter
  },
  // 按回车键注册
  created() {
    if (window.sessionStorage.getItem('f')) {
      this.f = true
      this.url = 'api/user/bregister'
    }
    document.onkeydown = e => {
      let key = window.event.keyCode
      if (key == 13) {
        // 执行注册事件
        this.register()
      }
    }
  },
  mounted() {
    const that = this
    let timer
    let m = 60
    // 用来标识是否可以发送验证码
    let flag = true
    $('.getCode').click(async function() {
      let moblie = that.registerInfo.mobile
      let event = 'register'
      if (!that.reg.test(moblie)) {
        that.$confirm('请输入11位有效手机号码', '提示')
        return
      }
      $('#c').focus()
      let paramss = new URLSearchParams()
      paramss.append('mobile', moblie)
      paramss.append('id', '')
      const { data: resul } = await that.$http({
        method: 'post',
        url: '/api/validate/check_mobile_available',
        data: paramss
      })
      if (resul.code == 0) {
        that.$confirm('该手机号码已经注册', '提示')
        return
      }
      if (flag) {
        $('.getCode').text('剩余' + m + '秒')
        flag = false
        timer = setInterval(() => {
          m--
          $('.getCode').text('剩余' + m + '秒')
          flag = false
          if (m <= 0) {
            clearInterval(timer)
            $('.getCode').text('再次获取验证码')
            m = 60
            flag = true
          }
        }, 1000)
        let param = new URLSearchParams()
        param.append('mobile', moblie)
        param.append('event', event)
        const res = await that.$http.post('/api/sms/send', param)
      }
    })
  },
  methods: {
    bangding(ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          let param = new URLSearchParams()
          param.append('id', window.sessionStorage.getItem('id'))
          param.append('account', this.ruleForm.account)
          param.append('password', this.ruleForm.password)

          const { data: res } = await this.$http({
            method: 'post',
            url: 'api/user/buser',
            data: param
          })
          if (res.code == 1) {
            this.$confirm(
              '微信与账户绑定成功，您以后可以直接扫码登陆！',
              '提示',
              {}
            )
              .then(() => {
                window.sessionStorage.removeItem('f')
                window.sessionStorage.removeItem('id')
                let userObj = {
                  id: res.data.userinfo.id,
                  username: res.data.userinfo.username,
                  mobile: res.data.userinfo.mobile,
                  avatar: res.data.userinfo.avatar
                }
                window.localStorage.setItem('token', res.data.userinfo.token)
                window.localStorage.setItem('u', JSON.stringify(userObj))
                this.$message.success('登陆成功!')
                this.$router.push('/')
              })
              .catch(() => {})
          }
          if (res.code == 0) {
            this.$confirm(res.msg, '提示')
          }
        } else {
          return false
        }
      })
    },
    goLogin() {
      this.$router.push('/login')
    },
    calibration() {
      if (this.reg.test(this.registerInfo.mobile)) return (this.flag = true)
      return (this.flag = false)
    },
    async register() {
      let info = this.registerInfo
      if (!this.reg.test(info.mobile)) {
        this.$message.error('请输入11位有效手机号码')
        return
      }
      if (!info.password.trim()) {
        return this.$message.error('请输入密码')
      }
      if (info.password.trim().length < 8) {
        return this.$message.error('请输入8位以上的密码')
      }
      if (!info.code.trim()) {
        return this.$message.error('请输入验证码')
      }
      if (info.code.trim().length < 4) {
        return this.$message.error('请输入四位数字验证码')
      }
      if (!info.jname.trim()) {
        return this.$message.error('请输入用户名称')
      }
      if (info.jname.trim().length < 1) {
        return this.$message.error('用户名称至少2个字')
      }

      if (!this.checkVal) {
        return this.$message.error('请勾选同意协议方可注册')
      }

      let params = new URLSearchParams()
      params.append('mobile', info.mobile)
      params.append('jname', info.jname)
      params.append('event', 'register')
      params.append('captcha', info.code)
      const { data: result } = await this.$http.post('/api/sms/check', params)
      if (result.code !== 1) {
        return this.$message.error('验证码错误，请核对后输入')
      } else if (result.code == 1) {
        let param = new URLSearchParams()
        if (this.f == false) {
          for (let key in info) {
            param.append(key, info[key])
          }
        } else {
          param.append('id', window.sessionStorage.getItem('id'))
          param.append('username', info.mobile)
          param.append('jname', info.jname)
          param.append('mobile', info.mobile)
          param.append('password', info.password)
        }
        const { data: res } = await this.$http.post(this.url, param)
        if (res.code == 1) {
          if (window.sessionStorage.getItem('f')) {
            window.sessionStorage.removeItem('f')
            window.sessionStorage.removeItem('id')
            this.$confirm(
              '绑定手机号码成功,以后您可以通过微信扫描二维码进行登陆?',
              '注册成功',
              {
                confirmButtonText: '确定',
                type: 'warning'
              }
            )
              .then(() => {
                this.$router.push('/login')
              })
              .catch(() => {})
            return
          }
          this.$confirmm('注册成功,点击确定立即登陆', '提示', {
            confirmButtonText: '确定',
            type: 'success'
          }).then(async () => {
            let params = new URLSearchParams()
            params.append('account', info.mobile)
            params.append('password', info.password)
            const { data: result } = await this.$http({
              method: 'post',
              url: 'api/user/login',
              data: params
            })
            this.$message.success('登陆成功！')
            let userobj = {
              id: result.data.userinfo.id,
              username: result.data.userinfo.username,
              mobile: result.data.userinfo.mobile,
              avatar: result.data.userinfo.avatar,
              expiretime: result.data.userinfo.expiretime,
              nickname: result.data.userinfo.nickname
            }
            window.localStorage.setItem('token', result.data.userinfo.token)
            window.localStorage.setItem('u', JSON.stringify(userobj))
            this.$router.push('/index')
          })
        } else {
          return this.$message.error('注册失败！' + res.msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 600px;
  background: url('../assets/images/banner.png');
  .w {
    .check {
      -webkit-appearance: none;
      appearance: none;
      outline: none;
      width: 20px;
      height: 20px;
      cursor: pointer;
      vertical-align: center;
      background: #fff;
      border: 1px solid #ccc;
      position: relative;
    }
    .check:checked::after {
      content: '\2713';
      display: block;
      position: absolute;
      top: 4px;
      left: 2px;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      line-height: 10px;
      color: #ffa525;
      font-size: 18px;
    }
    .register {
      box-sizing: border-box;
      position: relative;
      top: 75px;
      right: 0;
      bottom: 75px;
      float: right;
      padding: 35px 22px 25px 22px;
      width: 383px;
      height: 475px;
      background-color: #fff;
      border-radius: 15px;
      .title {
        margin-bottom: 30px;
        font-size: 24px;
        color: #333;
      }
      .uname,
      .jname,
      .password,
      .phoneCode {
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        margin-botqingtom: 20px;
        background-color: #eef2f5;
        border-radius: 10px;
        padding: 12px 20px;
        span {
          width: 19px;
          height: 22px;
        }
        div {
          display: inline-block;
          width: 80%;
          margin-left: 20px;
          input {
            width: 100%;
            background-color: #eef2f5;
            font-size: 16px;
          }
        }
      }
      .phoneCode {
        position: relative;
        .getCode {
          position: absolute;
          right: 5px;
          top: 5px;
          bottom: 5px;
          padding: 0 20px;
          height: 38px;
          background-color: #e5fff3;
          color: #43d590;
          cursor: pointer;
        }
      }
      .option {
        font-size: 14px;
        .gx {
          display: inline-block;
        }
        .left {
          float: left;
          cursor: pointer;
          span {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            width: 30px;
            height: 30px;
            background: url(../assets/icons/checkBox.png) no-repeat;
          }
        }
      }
      .register-btn {
        margin-top: 20px;
        width: 342px;
        height: 48px;
        background: url(../assets/images/login.png) no-repeat;
        cursor: pointer;
        font-size: 22px;
        color: #fff;
      }
      .register-methods {
        margin-top: 4px;
        bottom: 25px;
        width: 100%;
        a {
          float: right;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
